/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import "./DoctorCard.css";

const DoctorCards = ({
  id,
  fname,
  lname,
  address,
  bio,
  city,
  country,
  rating,
  categories,
}) => {
  const elements = [];

  for (let i = 1; i <= rating; i++) {
    elements.push(<i class="icon_star voted"></i>);
    // setRating(elements);
  }
  console.log(categories,"categories")

  return (
    <>
      <>
        <div class="col-lg-12 col-md-6">
          <div class="ag-courses_box">
            <div class="ag-courses_item">
              <Link to={"/details?id=" + id} class="ag-courses-item_link">
                <div class="ag-courses-item_bg"></div>

                <div class="ag-courses-item_title">{fname}</div>

                {/* <div class="ag-courses-item_date-box"> */}

                <div className="review">
                  <div>
                    <h4 className="text-light fw-bolder">({rating})</h4>
                    {/* <br /> */}
                    <h6 className="text-light fw-bolder">Rating</h6>
                  </div>
                  <div className="">
                    <h4 className="text-light fw-bolder">${categories?.length > 0
                      ? Math.min(...categories.map(category => parseInt(category.fee)))
                      : categories?.map(category => Number(category.fee))}</h4>
                    {/* <br /> */}
                    <h6 className="text-light fw-bolder">Fee</h6>
                  </div>
                </div>
                {/* </div> */}
                <div class="ag-courses-item_date-box my-2 text-center">
                  {bio}
                </div>

                <div className="text-center">
                  {rating === 0 ? <i className="icon_star"></i> : elements}
                </div>
                <button className="btn btn-outline-light mx-auto d-block w-100 mt-3">Detail</button>
                <div class="ag-courses-item_date-box-address">
                  {address} <span className="text-dark">|</span> {city}{" "}
                  <span className="text-dark">|</span> {country}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default DoctorCards;
